module.exports = __webpack_public_path__ + "img/trinapp_projects.b3bb41bc.png";